// 모바일 하단 탭바(MobileTabBar) 높이 — 여백·위치 계산은 전부 이 값 하나에서 나온다(g2829b).
// 바꾸면 탭바 몫 여백(.gw-tabbar-pad 등)·떠 있는 버튼·재생바·띠 위치가 함께 움직인다.
// ChatInput 의 88/76(도구 팝업 위치 · 출처 미확인) · 탭 단추 minHeight 56(MobileTabBar) 은 아직 이 값과 묶이지 않았다 (ChatPage 62 는 g2829c2 에서 묶었다).
export const TABBAR_H = 60;

// 탭바 위로 extra px 띄운 바닥 거리 — `calc(<TABBAR_H+extra>px + env(safe-area-inset-bottom))`.
export function tabbarCalc(extra = 0) {
  return `calc(${TABBAR_H + extra}px + env(safe-area-inset-bottom))`;
}
